import { EPlatFormType, EVerifyCode, EVerifySubCode } from "./enum";

export const statusMsg = {
    
} 

export const ResultStatus = {
    success: 1, // 审核通过
    fail: 2, // 审核拒绝
    pending: 0, // 等待评分
    pendingManualScore: 3, // 等待人工审核
    pendingSysScore: 4, // 待正文匹配
    publicizing: 5, // 公示中
    publicityEnded: 6, // 公示借宿
    pandingResult: 7, // 等待结果审核，比如锁定的账号
    preventFix: 12, //阻止修复中
    needVerifyFace: 13, //需要验证人脸
    smartQuestion: 15, // 智能问答
    extensionFileProcess: 16, // 扩展资料提交流程
}

export const RISK_CONTROL = -1;

export const RepairWay = {
    vipRepair: 0,  // vip修复方式
    dataRepair: 1, // 资料修复方式
    lowValueBankCard: 2,  // 低价值账号银行卡方式
    lowValueHoldingIDCard: 3, // 低价值账号手持身份证方式
    lowValueExplainBankCard: 4, // 低价值账号申诉 银行卡方式
    lowValueExplainHoldingIDCard: 5, // 低价值账号申诉 手持身份证方式 
}

export const VerifyFaceMessage = {
    [EVerifyCode.SUCCESS]: "刷脸成功",
    [EVerifyCode.SYSTEM_ERROR]: '系统错误',
    [EVerifyCode.VERIFY_AORT]: '验证中断',
    [EVerifyCode.CLIENT_TIME_ERROR]: '客户端设备时间错误',
    [EVerifyCode.VERIFY_FAIL]: '刷脸失败',
}

export const VerifyDetailMessage = {
    [EVerifySubCode.VERIFY_SUCCESS]: '人脸验证成功',
    [EVerifySubCode.UPLOAD_IMAGE_FAIL]: '上传刷脸图片失败',
    [EVerifySubCode.DATA_ERROR_OR_EXCEPTION]: '数据错误或程序异常',
    [EVerifySubCode.NETWORK_ERROR]: '网络错误',
    [EVerifySubCode.CAMERA_NO_READY]: '摄像头未就绪',
    [EVerifySubCode.USER_CANCEL]: '你已主动退出',
    [EVerifySubCode.VERIFY_LIMIT]: '重试次数过多',
    [EVerifySubCode.UPLOAD_VIDEO_TIMEOUT]: '上传视频超时',
    [EVerifySubCode.VIDEO_FORMAT_ERROR]: '视频格式不满足要求',
    [EVerifySubCode.VERIFY_NO_FACE]: '未检测到人脸信息',
    [EVerifySubCode.NO_SAME_PERSON_FACE]: '人脸信息未匹配',
}

// 第三房平台映射
export const ExternalPlatformName = {
    [EPlatFormType.WECHAT]: '微信公众平台',
    [EPlatFormType.BLIZZARD]: '暴雪战网平台',
    [EPlatFormType.AMAZON]: '亚马逊平台',
    [EPlatFormType.APPLEID]: 'Apple ID',
    [EPlatFormType.STEAM]: 'STEAM账号',
    [EPlatFormType.OTHER]: '其他',
}

export const SMSMoURL = `https://mail.163.com/html/200217_sms/sendsms.html?smsCode=5166&title=帐号修复中心&btnText=我已发送&hl=zh_CN`;
export const SMART_QUESTION_URL = `https://mail.163.com/projects/acrepair-ai/`;